var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.name,"width":800,"footer":null,"centered":"","destroyOnClose":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('k-form-build',{attrs:{"value":_vm.jsonData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }